export default {
    aftershock: {
        name: "Aftershock",
        url: "nfpa_emergency_natural_events_symbology/aftershock",
    },
    avalanche: {
        name: "Avalanche",
        url: "nfpa_emergency_natural_events_symbology/avalanche",
    },
    bird_infestation: {
        name: "Bird Infestation",
        url: "nfpa_emergency_natural_events_symbology/bird_infestation",
    },
    drizzle: {
        name: "Drizzle",
        url: "nfpa_emergency_natural_events_symbology/drizzle",
    },
    drought: {
        name: "Drought",
        url: "nfpa_emergency_natural_events_symbology/drought",
    },
    earthquake_epicenter: {
        name: "Earthquake Epicenter",
        url: "nfpa_emergency_natural_events_symbology/earthquake_epicenter",
    },
    flood_2: {
        name: "Flood 2",
        url: "nfpa_emergency_natural_events_symbology/flood_2",
    },
    fog: {
        name: "Fog",
        url: "nfpa_emergency_natural_events_symbology/fog",
    },
    hail: {
        name: "Hail",
        url: "nfpa_emergency_natural_events_symbology/hail",
    },
    insect_infestation: {
        name: "Insect Infestation",
        url: "nfpa_emergency_natural_events_symbology/insect_infestation",
    },
    inversion: {
        name: "Inversion",
        url: "nfpa_emergency_natural_events_symbology/inversion",
    },
    landslide: {
        name: "Landslide",
        url: "nfpa_emergency_natural_events_symbology/landslide",
    },
    microbial_infestation: {
        name: "Microbial Infestation",
        url: "nfpa_emergency_natural_events_symbology/microbial_infestation",
    },
    rain: {
        name: "Rain",
        url: "nfpa_emergency_natural_events_symbology/rain",
    },
    reptile_infestation: {
        name: "Reptile Infestation",
        url: "nfpa_emergency_natural_events_symbology/reptile_infestation",
    },
    rodent_infestation: {
        name: "Rodent Infestation",
        url: "nfpa_emergency_natural_events_symbology/rodent_infestation",
    },
    sand_dust_storm: {
        name: "Sand Dust Storm",
        url: "nfpa_emergency_natural_events_symbology/sand_dust_storm",
    },
    subsidence: {
        name: "Subsidence",
        url: "nfpa_emergency_natural_events_symbology/subsidence",
    },
    thunderstorm: {
        name: "Thunderstorm",
        url: "nfpa_emergency_natural_events_symbology/thunderstorm",
    },
    tornado: {
        name: "Tornado",
        url: "nfpa_emergency_natural_events_symbology/tornado",
    },
    tropical_cyclone: {
        name: "Tropical Cyclone",
        url: "nfpa_emergency_natural_events_symbology/tropical_cyclone",
    },
    tsunami: {
        name: "Tsunami",
        url: "nfpa_emergency_natural_events_symbology/tsunami",
    },
    volcanic_eruption: {
        name: "Volcanic Eruption",
        url: "nfpa_emergency_natural_events_symbology/volcanic_eruption",
    },
    volcanic_threat: {
        name: "Volcanic Threat",
        url: "nfpa_emergency_natural_events_symbology/volcanic_threat",
    },
}
